module.exports = __webpack_public_path__ + "media/images/icons/account_tree-3ce6583c12095ca5068100e13a342d45.svg";